import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { useBrand } from '@/config/brands';
import { useTranslation } from 'react-i18next';
import { RTL_LANGUAGES } from '@/i18n';

export function DarkModeToggle() {
  const { isDark, toggle } = useTheme();
  const brand = useBrand();
  const { t, i18n } = useTranslation();
  const isRTL = RTL_LANGUAGES.has((i18n.language?.substring(0, 2) || 'en') as any);

  // AHP and AntiGreed have the toggle in their own headers
  if (brand.key === 'ahp' || brand.key === 'antigreed') return null;

  // Luigi's / AntiGreed — matrix green floating button
  const buttonStyle: React.CSSProperties = {
    background: 'rgba(0,255,65,0.08)',
    border: '1px solid rgba(0,255,65,0.25)',
    color: '#00ff41',
  };

  const label = isDark ? t('darkMode.switchToLight') : t('darkMode.switchToDark');

  const positionStyle: React.CSSProperties = isRTL
    ? { left: '16px' }
    : { right: '16px' };

  return (
    <button
      onClick={toggle}
      aria-label={label}
      title={label}
      style={{
        position: 'fixed',
        top: '91px',
        zIndex: 9999,
        width: '38px',
        height: '38px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        backdropFilter: 'blur(8px)',
        transition: 'all 0.2s ease',
        ...positionStyle,
        ...buttonStyle,
      }}
      onMouseEnter={e => {
        (e.currentTarget as HTMLButtonElement).style.opacity = '0.8';
        (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.08)';
      }}
      onMouseLeave={e => {
        (e.currentTarget as HTMLButtonElement).style.opacity = '1';
        (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
      }}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
